import { createFileRoute } from "@tanstack/react-router";
import { CompanyScreen } from "../screens/staff/CompanyScreen.tsx";

/** `/sysadmin/companies/:id`: one company as staff see it. Asking for run-log access goes through the operator page. */
export const Route = createFileRoute("/_staff/sysadmin/companies/$companyId")({
  component: CompanyScreen,
});
